// extracted by mini-css-extract-plugin
export default {"wrapper":"Continue_wrapper__RFinJ","tableName":"Continue_tableName__b+zsn"};